export const HOME = '/';

export const SEARCH = '/search';

export const LOCATION = '/organization/:organizationUid/location/:locationUid';

export const LOCATION_USERS =
  '/organization/:organizationUid/location/:locationUid/users';

export const LOCATION_REVIEW_SITES =
  '/organization/:organizationUid/location/:locationUid/review-sites';

export const LOCATION_REVIEWS =
  '/organization/:organizationUid/location/:locationUid/reviews';

export const LOCATION_INVITATION =
  '/organization/:organizationUid/location/:locationUid/invitation';

export const LOCATION_IFRAME =
  '/organization/:organizationUid/location/:locationUid/iframe';

export const LOCATION_FEEDBACK =
  '/organization/:organizationUid/location/:locationUid/feedback';

export const LOCATION_PHONE_NUMBERS =
  '/organization/:organizationUid/location/:locationUid/phone-numbers';

export const LOCATION_AUTOMATIONS =
  '/organization/:organizationUid/location/:locationUid/automations';

export const LOCATION_LIMITS =
  '/organization/:organizationUid/location/:locationUid/limits';

export const LOCATION_VOICE =
  '/organization/:organizationUid/location/:locationUid/phones';

export const WEBCHAT_LOCATION =
  '/organization/:organizationUid/location/:locationUid/webchat-location';

export const LOCATION_CFL =
  '/organization/:organizationUid/location/:locationUid/contact-form-leads';

export const PRODUCTS =
  '/organization/:organizationUid/location/:locationUid/products';

export const LOCATION_AI =
  '/organization/:organizationUid/location/:locationUid/ai';

export const ORGANIZATION = '/organization/:organizationUid';
export const BULK_LOCATION = '/organization/:organizationId/bulk-location';
export const ORGANIZATION_LOCATIONS =
  '/organization/:organizationUid/locations';
export const ORGANIZATION_REPORTING = '/organization/:organizationId/reporting';
export const ORGANIZATION_USERS = '/organization/:organizationUid/users';
export const ORGANIZATION_PRODUCTS = '/organization/:organizationUid/products';
export const ORGANIZATION_SETTINGS = '/organization/:organizationUid/settings';
export const ORGANIZATION_HISTORY = '/organization/:organizationUid/history';
export const ORGANIZATION_TEAMCHAT = '/organization/:organizationId/teamchat';
export const ORGANIZATION_CAMPAIGNS = '/organization/:organizationId/campaigns';
export const ORGANIZATION_NEW = '/organizationNew';

export const PARTIAL_LOCATIONS = '/locations';
export const PARTIAL_LOCATIONS_PARTNERS = '/locations/partners';

export const PARTNER = '/partner/:partnerUid';
export const PARTNER_NEW = '/partnerNew';
export const PARTNERS = '/partners';
export const PARTNER_ORGANIZATIONS = '/partner/:partnerUid/organizations';
export const PARTNER_ADMINS = '/partner/:partnerUid/admins';

export const ROGBOT = '/rogbot';
export const ROGBOT_USERS = '/rogbot/users';
export const PROFILE = '/profile';
export const PROFILE_DETAILS = '/profile/:userUid';
export const FAVORITES = '/favorites';

export const TOOLS = '/tools';
export const PHONE_LOOKUP = '/tools/phone-lookup';
export const DELETE_CONVERSATION = '/tools/delete-conversation';
export const PHONE_TRANSFER_BY_UID = '/tools/phone-transfer/:locationUid';
export const PHONE_TRANSFER = '/tools/phone-transfer';
export const UNLAUNCH_GBM = '/tools/unlaunch-gbm';
export const INTEGRATIONS = '/integrations';
export const MARKETPLACE = '/marketplace';
export const AUTOMATIONS = '/automations';
export const AUTOMATIONS_ADD_TEMPLATE = '/automations/new-template';
export const AUTOMATIONS_EDIT_TEMPLATE = '/automations/edit-template/:uid';
export const MARKETPLACE_NEW_APP = '/marketplace/new-app';
export const MARKETPLACE_APP = '/marketplace/app/:appUid';
export const MARKETPLACE_APP_UPDATE_DATA_MAPPING =
  '/marketplace/app/:appUid/data-mappings/:dataMappingUid';
export const MARKETPLACE_APP_DATA_MAPPINGS =
  '/marketplace/app/:appUid/data-mappings';
export const AUTOMATIONS_ADD_SOLUTION =
  '/automations/new-solution/:title/:type';
export const AUTOMATIONS_EDIT_SOLUTION =
  '/automations/edit-solution/:title/:uid';
export const AUTOMATIONS_LIST_SOLUTIONS = '/automations/solutions';
export const MARKETPLACE_ASSOCIATE_APPS = '/marketplace/associate-apps';

export const ORGANIZATION_THREAT_MANAGEMENT =
  '/organization/:organizationUid/threat-management';

export const TRIAL_MANAGEMENT =
  '/organization/:organizationUid/trial-management';

export const REQUEST_MOCKS = '/organization/:organizationUid/request-mocks';

export const DATA_PRIVACY_REQUESTS =
  '/organization/:organizationUid/data-privacy-requests';
export const DATA_PRIVACY_REQUEST_DISPLAY =
  '/organization/:organizationUid/data-privacy-requests/:dataPrivacyRequestUid';

export const LOGOUT = '/logout';
